<template>
<div class="form-label-group">
    <!-- <strong>
    <span class="text-danger" v-if="required">*</span>
        Select Location
    </strong> -->

    <Select2 v-model="location_id" 
        :options="locations"
        name="location_id"
        id="location_id"
        :settings="{ placeholder: 'Select Store Location',allowClear:true}" :required="required"
        />
</div>
</template>

<script>
import Select2 from 'v-select2-component';

    export default {
        props:['location'],
        computed:{
            locations: function(){
                var data = [];
                this.locations_data.map( (obj) => {
                    data.push({id:obj.id,text:obj.name});
                });
                return data;
            }
        },
        components: {Select2},
        
        created(){
            let vm=this;
            vm.location_id = vm.location;
            axios.get(`/locations/get-all`)
                .then(function (response) {
                    vm.locations_data = response.data;

                })
                .catch(function (errors) {
                    // console.log(errors);
                    vm.showErrorMessage('Someting Went wrong.'); 
                });
        },
        props:{required:{default:false},name:{default:'Location'},location_id_prop:{default:''}},
        data(){
            return {
                locations_data:[],
                location_id:this.location_id_prop,
            }
        },
    }
</script>

<style>
.select2-container{
    width:100% !important;
}
</style>